/**
 * Rótulos e constantes da gestão de recursos da agenda (Plano 2 setup).
 * O recurso é a unidade-calendário (cadeira/sala/profissional/equipamento) — decisão D1
 * do Bloco I. `capacity>1` = grupo (sala de pilates); `=1` = exclusivo (cadeira/profissional).
 */
import type { SchedulingResourceWire } from '../../lib/api-client';

export type ResourceType = SchedulingResourceWire['resourceType'];

/** Ordem canônica de exibição dos tipos. */
export const RESOURCE_TYPE_ORDER: readonly ResourceType[] = [
  'professional',
  'room',
  'chair',
  'equipment',
  'other',
];

const RESOURCE_TYPE_LABELS: Record<ResourceType, string> = {
  professional: 'Profissional',
  room: 'Sala',
  chair: 'Cadeira',
  equipment: 'Equipamento',
  other: 'Outro',
};

export function resourceTypeLabel(type: ResourceType): string {
  return RESOURCE_TYPE_LABELS[type];
}

/** Plural do grupo de um tipo (cabeçalho de seção). */
const RESOURCE_TYPE_LABELS_PLURAL: Record<ResourceType, string> = {
  professional: 'Profissionais',
  room: 'Salas',
  chair: 'Cadeiras',
  equipment: 'Equipamentos',
  other: 'Outros',
};

export function resourceTypeLabelPlural(type: ResourceType): string {
  return RESOURCE_TYPE_LABELS_PLURAL[type];
}

/**
 * Fusos comuns no Brasil (curado — cobre os negócios reais da plataforma; o backend
 * re-valida IANA). Default America/Sao_Paulo. Lista enxuta evita um <select> com 400 zonas.
 */
export const COMMON_TIMEZONES: readonly { value: string; label: string }[] = [
  { value: 'America/Sao_Paulo', label: 'São Paulo / Brasília (GMT-3)' },
  { value: 'America/Bahia', label: 'Salvador (GMT-3)' },
  { value: 'America/Fortaleza', label: 'Fortaleza (GMT-3)' },
  { value: 'America/Recife', label: 'Recife (GMT-3)' },
  { value: 'America/Belem', label: 'Belém (GMT-3)' },
  { value: 'America/Cuiaba', label: 'Cuiabá (GMT-4)' },
  { value: 'America/Manaus', label: 'Manaus (GMT-4)' },
  { value: 'America/Porto_Velho', label: 'Porto Velho (GMT-4)' },
  { value: 'America/Rio_Branco', label: 'Rio Branco (GMT-5)' },
  { value: 'America/Noronha', label: 'Fernando de Noronha (GMT-2)' },
];

export const DEFAULT_TIMEZONE = 'America/Sao_Paulo';
